<template>
<div class="trip-detail-wrapper">
  <Error @reload="getDetail()" v-if="networkError" />
  <div class="trip-detail" v-else :class="{'has-site': detail.plan_sites.length > 0, 'show-site': showPopup}">
    <div id="map"></div>
    <div class="current-locate" @click="locateUser" :class="{'has-popup': showPopup, 'no-sites': detail.plan_sites.length === 0}">
      <img src="../assets/locator-sentosa-orange.svg" alt="" v-if="showLocateMarker">
      <img src="../assets/locator-sentosa.svg" alt="" v-else>
    </div>
    <div class="current-marker" ref="marker">
      <div class="circle">
        <div class="arrow"></div>
      </div>
    </div>
    <div class="trip-wrapper"
        v-if="detail.plan_sites.length > 0"
        v-show="!showPopup"
        :style="showPopup ? 'display: none:' : ''">
      <div class="swiper-wrap">
        <cube-slide class="scroll-wrapper"
                    :data="detail.plan_sites"
                    :initialIndex="currentSlide"
                    :loop="false"
                    :autoPlay="false"
                    :showDots="false"
                    @change="handleSlideChange">
          <cube-slide-item v-for="(item, index) in detail.plan_sites" :key="item.id">
            <div class="site-wrapper"
                @click="handleDetail(item.site_type, item.site.id)">
              <div class="card" ref="card">
                <div class="card-img">
                  <img v-lazy="generateObj(item.image)" />
                </div>
                <div class="card-detail">
                  <div class="card-title">{{ item.site.name }}</div>
                  <div class="card-time" v-if="item.type === 'Site' || item.type === 'SiteShop' || item.type === 'SiteActivity'">开放时间: {{ item.site.operation_time || '待补充' }}</div>
                  <div class="card-time" v-else-if="item.type === 'ShowItem'">演出时间: {{ item.site.time || '待补充' }}</div>
                  <div class="card-time" v-else-if="item.type === 'Merchant'">营业时间: {{ item.site.open || '待补充' }}</div>
                  <div class="card-play" v-if="item.type === 'Site' && item.visiting_time">建议游玩: {{ item.visiting_time || '待补充' }}</div>
                  <div class="card-play" v-else-if="item.type === 'ShowItem'">建议游玩: {{ item.site.play_strategy || '待补充' }}</div>
                </div>
                <div class="card-btns">
                  <div class="navigate-btn" @click.stop="handleNavigate(index)">
                    <img src="../assets/trip/nav-sentosa-orange.svg" />
                  </div>
                  <img class="delete" @click.stop="handleDelete(index)" src="../assets/trip/delete-sentosa.svg" />
                </div>
              </div>
              <div class="route" v-if="item.route" @click.stop="handleNavigateRoute(index)">
                <div class="route-img">
                  <img src="../assets/navigate/bus-gray-sentosa.svg" v-if="item.route.vehicle === 'bus'" />
                  <img src="../assets/navigate/walk-gray.svg" v-if="item.route.vehicle === 'foot'" />
                </div>
                <div class="number" v-html="item.route.time"></div>
              </div>
              <div class="route" v-else />
            </div>
          </cube-slide-item>
        </cube-slide>
      </div>
      <div class="optimize-btn" v-if="detail.plan_sites.length > 2" @click="handleOptimize">
        <img src="../assets/trip/auto-optimize.svg" />
      </div>
      <div class="add-btn" @click="handleAddSiteList">
        <img src="../assets/trip/plus.svg" />
        <span>添加行程</span>
      </div>
    </div>
    <div class="filter-btn" :class="{'has-site': detail.plan_sites.length > 0, 'show-site': showPopup}" @click="handleFilter">
      <img src="../assets/trip/planner-filter-sentosa.svg" />
    </div>
    <div class="popup-wrapper"
        ref="popup"
        v-show="popupDetail.id && (popupDetail.type === 'Site' || popupDetail.type === 'Merchant' || popupDetail.type === 'ShowItem' || popupDetail.type === 'SiteActivity')">
      <div class="trip-popup"
          :style="popupDetail.inTrip ? 'padding-left: 9px': 'padding-left: 15px'">
        <div class="remove-trip" v-if="popupDetail.inTrip" @click="handleRemoveSite">
          <img src="../assets/trip/delete-sentosa.svg" />
          <div class="text">从行程中删除</div>
        </div>
        <div class="add-trip" v-else @click="handleAddSite">
          <img src="../assets/add.svg" />
          <div class="text">添加到行程</div>
        </div>
        <div class="set-start" @click="handleSetStart">
          <img src="../assets/start.svg" />
          <div class="text">设置为起点</div>
        </div>
      </div>
    </div>
    <!-- 景点信息框 -->
    <div class="info-window" v-if="showPopup" @click="handleDetail(popupDetail.type, popupDetail.id)">
      <div class="info-img">
        <img v-lazy="generateObj(popupDetail.image)" />
      </div>
      <div class="info-detail">
        <div class="info-name">{{ popupDetail.name }}</div>
        <div class="info-labels" v-if="popupDetail.labels && popupDetail.labels.length > 0">
          <div class="label" v-for="item in popupDetail.labels" :key="item">{{ item }}</div>
        </div>
        <div class="info-footer">
          <Score :rating="popupDetail.rating" v-if="popupDetail.rating && (popupDetail.type === 'Site' || popupDetail.type === 'Merchant' ||  popupDetail.type === 'Hotel' || popupDetail.type === 'ShowItem')" />
          <div class="info-price" v-if="popupDetail.best_price">
            <div class="price-text">S${{ popupDetail.best_price / 100 }}</div>
            <div class="price-icon">起</div>
          </div>
        </div>
      </div>
    </div>
    <!-- 更多筛选 -->
    <PoiGroups :poiGroups="poiGroups" :active="active" ref="poiGroups" @select="handleSelect" />
  </div>
</div>
</template>

<script>
import {
  getTripDetail,
  getPoiGroups,
  getAllPois,
  deletePlanSite,
  addTripSite,
  setAsStart,
  tripOptimize
} from '@/fetch/api'
import moment from 'moment'
import mapboxgl from 'mapbox-gl/dist/mapbox-gl.js'
import { GetDistance, formatMinutes, pointWithinThere } from '@/utils/index'
import PoiGroups from '@/components/PoiGroups'
import Score from '@/components/Score'
import _ from 'lodash'
import Error from '@/components/Error'

export default {
  data () {
    return {
      detail: {
        plan_sites: []
      },
      noData: false,
      poiGroups: [],
      active: null,
      pois: [],
      showPopup: false,
      popupDetail: {},
      header: {},
      isUserAllowedGeoLocation: false,
      inThere: false,
      startGeo: {},
      networkError: false,
      showLocateMarker: false,
      currentSlide: 0
    }
  },
  components: {
    PoiGroups,
    Score,
    Error
  },
  computed: {
    siteId () {
      return this.$store.state.siteId
    }
  },
  created () {
    this.bearing = 0
    // document.title = '行程详情'
    this.toast = this.$createToast({
      time: 0,
      txt: '加载中...',
      mask: true
    })
    this.toast.show()
    this.Android = window.navigator.userAgent.indexOf('Android') > -1 || navigator.userAgent.indexOf('Adr') > -1
    this.startUpdateLocation()
  },
  mounted () {
    mapboxgl.accessToken = 'pk.eyJ1IjoicHVzaGlhbiIsImEiOiJjaXdyaXptNDAweG1rMm90YmRnZHl0dDFpIn0.9kBN2eXNRe3uZ9VMoMhfhg'

    this.map = new mapboxgl.Map({
      container: 'map',
      style: 'mapbox://styles/pushian/cj8313byya3lp2so6gvh49efn',
      center: [103.82740222, 1.2527583],
      zoom: 12.6
      // bounds: new mapboxgl.LngLatBounds([103.852152, 1.260704], [103.804682, 1.267034])
    })

    this.map.on('click', () => {
      this.showPopup = false
    })

    this.map.on('load', () => {
      this.getPois()
      this.getDetail()
      this.getPoiList()
    })

    // 根据zoom设置透明度
    // this.map.on('zoomend', () => {
    //   this.changeOpacity()
    // })

    this.map.on('rotate', res => {
      const alpha = this.map.getBearing()
      console.log('=======rotateend', alpha)
      this.bearing = alpha
      // // console.log('停止旋转')
      // const marker = document.querySelector('.current-marker .circle')
      // marker.style.transform = `rotateZ(${this.markerBearning - this.bearing}deg)`
    })
  },
  methods: {
    generateObj (src) {
      return {
        src,
        error: '/image/default_img.jpg',
        loading: '/image/loading-img.jpg'
      }
    },
    getDetail () {
      const query = this.$route.query
      getTripDetail(query.id, {
        'X-CLIENT-ID': query.clientId,
        'X-ACCESS-TOKEN': query.token,
        'X-USER-ID': query.userId
      }).then(res => {
        this.toast.hide()
        this.header = {
          'X-CLIENT-ID': query.clientId,
          'X-ACCESS-TOKEN': query.token,
          'X-USER-ID': query.userId
        }
        this.detail = this.processData(res)
        this.noData = res.plan_sites.length === 0
        this.networkError = false
        this.$nextTick(() => {
          this.drawTripRoute()
        })
      }).catch(err => {
        this.toast.hide()
        console.log(err)
        this.networkError = true
      })
    },
    processData (trip) {
      trip.start_time = moment(trip.start_time).format('YYYY/MM/DD')
      for (let i = 0; i < trip.plan_sites.length - 1; i++) {
        const planSite = trip.plan_sites[i]
        if (!trip.routes[i]) continue
        planSite.route = trip.routes[i]
        planSite.route.start_lon = planSite.site.lon
        planSite.route.start_lat = planSite.site.lat
        planSite.route.start_name = planSite.site.name
        planSite.route.start_type = planSite.site_type
        planSite.route.start_site_id = planSite.site.id
        planSite.route.end_lon = trip.plan_sites[i + 1].site.lon
        planSite.route.end_lat = trip.plan_sites[i + 1].site.lat
        planSite.route.end_name = trip.plan_sites[i + 1].site.name
        planSite.route.end_type = trip.plan_sites[i + 1].site_type
        planSite.route.end_site_id = trip.plan_sites[i + 1].site.id
        planSite.route.time = formatMinutes(Math.round(planSite.route.time / 60000))
      }
      trip.total_hours = moment(trip.end_hour, 'HH:mm').diff(moment(trip.start_hour, 'HH:mm'), 'h')
      return trip
    },
    // 在地图上绘制行程路线
    drawTripRoute () {
      if (this.detail.plan_sites.length === 0) return
      const coordinates = this.detail.plan_sites.map(item => {
        return [item.site.lon, item.site.lat]
      })
      if (this.oldLayer) {
        this.map.removeLayer(this.oldLayer)
        this.map.removeSource(this.oldLayer)
      }
      this.map.addLayer({
        'id': 'route',
        'type': 'line',
        'source': {
          'type': 'geojson',
          'data': {
            'type': 'Feature',
            'geometry': {
              'type': 'LineString',
              'coordinates': coordinates
            }
          }
        },
        'layout': {
          'line-cap': 'round',
          'line-join': 'round'
        },
        'paint': {
          'line-width': 3,
          'line-color': 'rgba(0, 70, 70, 0.7)'
        }
      })
      this.oldLayer = 'route'
      const bounds = this.calcLonLat(this.detail)
      this.map.fitBounds(bounds, {
        padding: {
          top: 60,
          bottom: 180,
          left: 60,
          right: 60
        }
      })
      // this.drawSites()
      this.drawMarker()
    },
    // 计算[sw, ne]
    calcLonLat (detail) {
      let minLon = detail.plan_sites[0].site.lon
      let minLat = detail.plan_sites[0].site.lat
      let maxLon = detail.plan_sites[0].site.lon
      let maxLat = detail.plan_sites[0].site.lat
      detail.plan_sites.forEach(item => {
        if (item.site.lon < minLon) {
          minLon = item.site.lon
        } else if (item.site.lon > maxLon) {
          maxLon = item.site.lon
        }
        if (item.site.lat < minLat) {
          minLat = item.site.lat
        } else if (item.site.lat > maxLat) {
          maxLat = item.site.lat
        }
      })
      return [[minLon, minLat], [maxLon, maxLat]]
    },
    // 为地图添加image
    handleMapImage () {
      return new Promise((resolve, reject) => {
        if (this.map.hasImage('marker')) {
          resolve()
        } else {
          this.map.loadImage('/image/map/marker-bg.png', (error, image) => {
            if (error) {
              reject(error)
            } else {
              this.map.addImage('marker', image)
              resolve()
            }
          })
        }
      })
    },
    // 绘制plan site
    drawSites () {
      this.handleMapImage().then(res => {
        if (this.oldSite) {
          this.map.removeLayer(this.oldSite)
          this.map.removeSource(this.oldSite)
        }
        const features = this.detail.plan_sites.map((item, index) => {
          return {
            type: 'Feature',
            properties: {
              index: index + 1,
              planSite: item,
              icon: 'hotel'
            },
            geometry: {
              type: 'Point',
              coordinates: [item.site.lon, item.site.lat]
            }
          }
        })

        this.map.addLayer({
          id: 'site',
          type: 'symbol',
          source: {
            type: 'geojson',
            data: {
              type: 'FeatureCollection',
              features: features
            }
          },
          layout: {
            'icon-image': 'marker',
            'icon-size': 0.5,
            'text-field': ['get', 'index'],
            'text-size': 12,
            'text-offset': [0, -0.2],
            'icon-allow-overlap': true
          },
          paint: {
            'text-color': '#009098',
            'text-halo-color': '#009098',
            'text-halo-width': 0.2
          },
          filter: ['>=', 'index', 0]
        })
        this.oldSite = 'site'
        this.map.on('click', 'site', e => {
          console.log('点击了layer', e.features)
          const feature = e.features[0]
          const lngLat = e.lngLat
          const planSite = JSON.parse(feature.properties.planSite)
          this.popupDetail = {
            ...planSite.site,
            type: planSite.type,
            inTrip: true,
            planSiteId: planSite.id
          }
          this.$nextTick(() => {
            this.initPopup(feature, lngLat)
          })
        })
      })
    },
    // 添加起点终点icon
    drawMarker () {
      // 删除旧的marker
      if (this.markers && this.markers.length > 0) {
        this.markers.forEach(item => {
          item.remove()
        })
      }
      let markers = []
      this.detail.plan_sites.forEach((item, current) => {
        // create a DOM element for the marker
        const el = document.createElement('div')
        el.className = 'marker'
        el.innerText = current + 1
        el.style.width = '24px'
        el.style.height = '24px'
        el.style.borderRadius = '50%'
        el.style.border = '3px solid #009098'
        el.style.backgroundColor = '#ffffff'
        el.style.shadow = '0 2px 4px 0 rgba(0, 0, 0, 0.37)'
        el.style.display = 'flex'
        el.style.alignItems = 'center'
        el.style.justifyContent = 'center'
        el.style.fontSize = '12px'
        el.style.color = '#009098'
        el.addEventListener('click', (e) => {
          e.stopPropagation()
          this.popupDetail = {
            ...item.site,
            type: item.type,
            inTrip: true,
            planSiteId: item.id
          }
          console.log('marker 触发的弹窗', item.site)
          this.showPopup = false
          this.$nextTick(() => {
            this.initPopup({
              geometry: {
                coordinates: [item.site.lon, item.site.lat]
              }
            }, { lon: item.site.lon, lat: item.site.lat })
            this.currentSlide = current
          })
        })
        // add marker to map
        const marker = new mapboxgl.Marker(el)
          .setLngLat([item.site.lon, item.site.lat])
          .addTo(this.map)
        markers.push(marker)
      })
      this.markers = markers
    },
    calcData (zoom) {
      let minSize = 0.26
      let maxSize = 0.4
      let rate = 0.04
      if (this.siteId === '33') {
        minSize = 0.36
        maxSize = 0.5
        rate = 0.08
      }
      let opacity = zoom * 0.1 - 0.5
      let fontSize = zoom >= 15 ? (zoom - 15) * 0.8 + 8 : 0
      let fontOpacity = zoom >= 15 ? (zoom - 15) * 0.12 + 0.4 : 0
      let size = zoom * rate - 0.2

      if (size < minSize) {
        size = minSize
      } else if (size > maxSize) {
        size = maxSize
      }
      if (opacity > 1) {
        opacity = 1
      } else if (opacity < 0.7) {
        opacity = 0.7
      }
      if (fontSize > 12) fontSize = 12
      if (fontOpacity > 1) fontOpacity = 1
      const returnData = {
        opacity,
        fontOpacity,
        size,
        fontSize
      }
      return returnData
    },
    // 修改layer opactiy
    changeOpacity () {
      const zoom = this.map.getZoom()
      const data = this.calcData(zoom)

      console.log(data.size)
      for (let key in this.pois) {
        if (this.map.getLayer(key)) {
          this.map.setPaintProperty(key, 'icon-opacity', data.opacity).setLayoutProperty(key, 'icon-size', data.size)

          if (zoom > 15) { // 显示文字
            this.map.setPaintProperty(key, 'text-opacity', data.fontOpacity).setLayoutProperty(key, 'text-size', data.fontSize)
          } else {
            this.map.setPaintProperty(key, 'text-opacity', 0)
          }
        }
      }
    },
    handleFilter () {
      this.$refs.poiGroups.show()
    },
    // 获取poiGroups
    getPois () {
      getPoiGroups(1).then(res => {
        this.poiGroups = res.poi_groups.sort((a, b) => {
          return b.rank - a.rank
        })
      })
    },
    // 获取所有的景点
    getPoiList () {
      this.toast = this.$createToast({
        time: 0,
        txt: '加载中...',
        mask: true
      })
      this.toast.show()
      getAllPois(1).then(res => {
        // 处理poi。根据类型和groupId分组 
        const obj = _.groupBy(res.pois, item => `${item.type}-${item.poi_group_id}`)
        this.pois = obj
        this.$nextTick(() => {
          let promiseArray = []
          for (let key in obj) {
            promiseArray.push(this.loadImages({
              id: key,
              image_url: obj[key][0].poi_group_icon || '/image/map/SitePoint.png'
            }))
          }
          Promise.all(promiseArray).then(resArray => {
            this.renderLayer(obj)
          })
        })
      })
    },
    // 加载所有图片
    loadImages (poiGroup) {
      return new Promise((resolve, reject) => {
        this.map.loadImage(poiGroup.image_url, (error, image) => {
          console.log(error, image)
          if (error) {
            reject(error)
          } else {
            this.map.addImage(poiGroup.id, image)
            resolve()
          }
        })
      })
    },
    // 计算四个表达式
    calcExpression () {
      let iconSize = [
        'interpolate', ['linear'], ['zoom'],
        9, 0.26,
        18, 0.4
      ]
      let iconOpacity = [
        'interpolate', ['linear'], ['zoom'],
        9, 0.4,
        12.6, 1,
      ]
      if (this.siteId === '129') { // 新加坡
        iconSize = [
          'interpolate', ['linear'], ['zoom'],
          9, 0.26,
          18, 0.46
        ]
        iconOpacity = [
          'interpolate', ['linear'], ['zoom'],
          9, 0.4,
          18, 1
        ]
      } else if (this.siteId === '33') { // 德国
        iconSize = [
          'interpolate', ['linear'], ['zoom'],
          5, 0.24,
          18, 0.46
        ]
        iconOpacity = [
          'interpolate', ['linear'], ['zoom'],
          5, 0.4,
          18, 1
        ]
      }
      return { iconSize, iconOpacity }
    },
    // 根据type渲染layer
    renderLayer (obj) {
      let array = []
      for (let key in obj) {
        array.push({
          name: key,
          pois: obj[key]
        })
      }
      const sortedArray = _.cloneDeep(array).sort((a, b) => {
        const aType = a.name.split('-')[0]
        const bType = b.name.split('-')[0]
        if (aType === 'SiteStation' || aType === 'SitePoint' || aType === 'Toilet') {
          return -1
        }
        if (bType === 'SiteStation' || bType === 'SitePoint' || bType === 'Toilet') {
          return 1
        }
      })
      console.log('排序过后的数组', sortedArray)
      let zoom = 12.6
      if (this.siteId === '245') {
          zoom = 14.5
      } else if (this.siteId === '129') {
          zoom = 9
      } else if (this.siteId === '33') {
          zoom = 5
      } else {
          zoom = 12.6
      }
      const expression = this.calcExpression()
      sortedArray.forEach(poiGroup => {
        const features = poiGroup.pois.map(item => {
          const name = item.name.split('\r\n').join('')
          return {
            type: 'Feature',
            properties: {
              poi: item,
              icon: poiGroup.name,
              name: name
            },
            geometry: {
              type: 'Point',
              coordinates: [item.lon, item.lat]
            }
          }
        })
        this.map.addLayer({
          id: poiGroup.name,
          type: 'symbol',
          source: {
            type: 'geojson',
            data: {
              type: 'FeatureCollection',
              features: features
            }
          },
          layout: {
            'icon-image': poiGroup.name,
            'icon-size': expression.iconSize,
            'text-field': ['get', 'name'],
            'text-anchor': 'left',
            'text-justify': 'center',
            'text-offset': [1.5, 0],
            'text-size': [
              'interpolate', ['linear'], ['zoom'],
              13, 0,
              14, 8,
              20, 12
            ]
          },
          paint: {
            'text-color': '#222125',
            'icon-opacity': expression.iconOpacity,
            'text-opacity': [
              'interpolate', ['linear'], ['zoom'],
              14, 0,
              15, 0.5,
              20, 1
            ]
          }
        })
        // 点击layer显示popup
        this.map.on('click', poiGroup.name, e => {
          console.log('点击了layer', e.features)
          const feature = e.features[0]
          const lngLat = e.lngLat
          const poi = JSON.parse(feature.properties.poi)
          const planSite = this.detail.plan_sites.find(item => item.site.id === poi.id && item.type === poi.type)
          this.popupDetail = {
            ...poi,
            type: poiGroup.name.split('-')[0],
            inTrip: !!planSite,
            planSiteId: planSite ? planSite.id : ''
          }
          if (!planSite) {
            this.showPopup = true
          }
          this.$nextTick(() => {
            this.initPopup(feature, lngLat)
          })
        })
      })
    },
    // 点击查看详情
    handleDetail (type, id) {
      let path = ''
      if (type === 'Site') {
        path = `/packageScenic/pages/siteDetail/index?id=${id}&from=trip&tripId=${this.$route.query.id}`
      } else if (type === 'ShowItem') {
        path = `/packageScenic/pages/showDetail/index?id=${id}&from=trip&tripId=${this.$route.query.id}`
      } else if (type === 'Merchant') {
        path = `/packageScenic/pages/merchantDetail/index?id=${id}&from=trip&tripId=${this.$route.query.id}`
      } else if (type === 'SiteActivity') {
        path = `/packageScenic/pages/eventDetail/index?id=${id}&from=trip&tripId=${this.$route.query.id}`
      } else if (type === 'Hotel') {
        path = `/packageScenic/pages/hotelDetail/index?id=${id}`
      } else if (type === 'SiteShop') {
        path = `/packageScenic/pages/mallDetail/index?id=${id}`
      } else if (type === 'PoiPromotion') {
        path = `/packageScenic/pages/promotionDetail/index?id=${id}`
      }
      console.log('导航的地址', path)
      window.wx.miniProgram.navigateTo({
        url: path
      })
    },
    // 选择poiGroup
    handleSelect (index) {
      this.active = index
      this.showPopup = false
      if (index === -1) {
        for (let key in this.pois) {
          this.map.setLayoutProperty(key, 'visibility', 'visible')
        }
      } else {
        const selectedPoiGroup = this.poiGroups[index]
        const typeName = selectedPoiGroup.poi_type.split('_').map(item => {
          const type = item.slice(0, 1).toUpperCase() + item.slice(1)
          return type
        }).join('')
        console.log(typeName)
        for (let key in this.pois) {
          if (key === `${typeName}-${selectedPoiGroup.id}`) {
            this.map.setLayoutProperty(key, 'visibility', 'visible')
          } else {
            this.map.setLayoutProperty(key, 'visibility', 'none')
          }
        }
      }
    },
    // 导航
    handleNavigate (index) {
      const planSite = this.detail.plan_sites[index]
      // [start_lon, start_lat, start_name, start_type, start_id, end_lon, end_lat, end_name, end_type, end_id, longitude, latitude]
      const routeArray = ['', '', '', '', '', parseFloat(planSite.site.lon), parseFloat(planSite.site.lat), planSite.site.name, planSite.site_type, planSite.site.id]
      console.log('跳转地址', routeArray)
      window.wx.miniProgram.navigateTo({
        url: `/packageScenic/pages/navigateWeb/index?data=${encodeURIComponent(JSON.stringify(routeArray))}`
      })
    },
    handleNavigateRoute (index) {
      const route = this.detail.plan_sites[index].route
      const routeArray = [route.start_lon, route.start_lat, route.start_name, route.start_type, route.start_site_id, route.end_lon, route.end_lat, route.end_name, route.end_type, route.end_site_id]
      window.wx.miniProgram.navigateTo({
        url: `/packageScenic/pages/navigateWeb/index?data=${encodeURIComponent(JSON.stringify(routeArray))}`
      })
    },
    // 删除景点
    handleDelete (index) {
      const planSite = this.detail.plan_sites[index]
      this.handleDeleteModal(planSite.site.name, planSite.id)
    },
    // 显示弹窗
    initPopup (feature, lngLat) {
      console.log('初始化弹窗', feature, lngLat)
      if (this.popupDetail.type !== 'Site' && this.popupDetail.type !== 'Merchant' && this.popupDetail.type !== 'ShowItem' && this.popupDetail.type !== 'SiteActivity') {
        return
      }
      console.log('要显示弹窗')
      const coordinates = feature.geometry.coordinates.slice()

      while (Math.abs(lngLat.lng - coordinates[0]) > 180) {
        coordinates[0] += lngLat.lng > coordinates[0] ? 360 : -360
      }
      console.log(coordinates)
      if (this.popup) {
        this.popup.remove()
      }
      this.popup = new mapboxgl.Popup()
        .setLngLat(coordinates)
        .setDOMContent(this.$refs.popup)
        .addTo(this.map)

      this.map.flyTo({ center: feature.geometry.coordinates, zoom: 16 })
    },
    handleDeleteModal (name, id) {
      this.$createDialog({
        type: 'confirm',
        content: `确定将“${name}”从行程中删除吗?`,
        cancelBtn: {
          text: '删除',
          active: false,
          disabled: false,
          href: 'javascript:;'
        },
        confirmBtn: {
          text: '不舍得',
          active: true,
          disabled: false,
          href: 'javascript:;'
        },
        onConfirm: () => {
          // 点击不舍得触发，其实是取消
        },
        onCancel: () => {
          this.toast = this.$createToast({
            time: 0,
            txt: '加载中...',
            mask: true
          })
          this.toast.show()
          deletePlanSite(this.detail.id, {
            plan_site_id: id
          }, this.header).then(res => {
            this.toast.hide()
            const detail = this.processData(res)
            this.detail = detail
            this.$nextTick(() => {
              this.drawTripRoute()
            })
          })
        }
      }).show()
    },
    // 添加到行程
    handleAddSite () {
      this.toast = this.$createToast({
        time: 0,
        txt: '加载中...',
        mask: true
      })
      this.toast.show()
      this.popup.remove()
      this.showPopup = false
      addTripSite(this.detail.id, {
        site_id: this.popupDetail.id,
        site_type: this.popupDetail.type
      }, this.header).then(res => {
        this.toast.hide()
        this.detail = this.processData(res)
        this.$nextTick(() => {
          this.drawTripRoute()
        })
      })
    },
    // 从行程中删除
    handleRemoveSite () {
      this.showPopup = false
      this.popup.remove()
      this.handleDeleteModal(this.popupDetail.name, this.popupDetail.planSiteId)
    },
    // 设置喂起点
    handleSetStart () {
      this.toast = this.$createToast({
        time: 0,
        txt: '加载中...',
        mask: true
      })
      this.toast.show()
      this.showPopup = false
      this.popup.remove()
      let params = {}
      if (this.popupDetail.inTrip) {
        params.plan_site_id = this.popupDetail.planSiteId
      } else {
        params.site_id = this.popupDetail.id
        params.site_type = this.popupDetail.type
      }
      setAsStart(this.detail.id, params, this.header).then(res => {
        this.toast.hide()
        this.detail = this.processData(res)
        this.$nextTick(() => {
          this.drawTripRoute()
        })
      })
    },
    // 优化行程
    handleOptimize () {
      this.toast = this.$createToast({
        time: 0,
        txt: '加载中...',
        mask: true
      })
      this.toast.show()
      tripOptimize(this.detail.id, this.header).then(res => {
        this.toast.hide()
        this.detail = this.processData(res)
        this.$nextTick(() => {
          this.drawTripRoute()
        })
      })
    },
    // 添加景区到行程
    handleAddSiteList () {
      window.wx.miniProgram.navigateTo({
        url: `/packageScenic/pages/onlineTour/listPage/index?from=trip&travel_plan_id=${this.detail.id}`
      })
    },
    // 获取角度、位置信息
    startUpdateLocation () {
      if (this.Android) {
        window.addEventListener('deviceorientationabsolute', this.handleOrientationAbsolute)
      } else {
        window.addEventListener('deviceorientation', this.handleOrientation)
      }
      this.watchId = window.navigator.geolocation.watchPosition((res) => {
        this.isUserAllowedGeoLocation = true
        const longitude = res.coords.longitude
        const latitude = res.coords.latitude
        // console.log(longitude, latitude)
        if (longitude) {
          this.startGeo = {
            lon: longitude,
            lat: latitude
          }
          if (this.currentMarker) {
            this.currentMarker.setLngLat([longitude, latitude])
            this.currentMarker.addTo(this.map)
          }
        }
        this.inThere = pointWithinThere(longitude, latitude)
      }, err => {
        this.isUserAllowedGeoLocation = false
        console.log(err)
      }, {timeout: 20000, enableHighAccuracy: true})
    },
    handleOrientation (res) {
      const alpha = res.webkitCompassHeading
      // console.log('获取到的数据', alpha)
      // alert(`收到数据alpha: ${alpha}`)
      this.alpha = alpha
      this.deviceOrientationHandler(alpha)
    },
    handleOrientationAbsolute (res) {
      const alpha = 360 - res.alpha
      // console.log('获取到的数据', alpha)
      // alert(`收到数据alpha: ${alpha}`)
      this.alpha = alpha
      this.deviceOrientationHandler(alpha)
    },
    deviceOrientationHandler (alpha) {
      // console.log('收到的角度', alpha)
      if (!this.currentMarker) return
      console.log('有marker')
      const marker = document.querySelector('.current-marker .circle')
      // console.log('当前的marker', marker)
      marker.style.transform = `rotateZ(${alpha - this.bearing}deg)`
    },
    // 添加当前位置marker
    drawCurrentMarker (longitude, latitude) {
      // add marker to map
      this.showLocateMarker = true
      const marker = new mapboxgl.Marker(this.$refs.marker)
        .setLngLat([longitude, latitude])
        .addTo(this.map)
      this.currentMarker = marker
    },
    // 点击按钮定位到当前位置
    locateUser () {
      if (!this.isUserAllowedGeoLocation) {
        this.$createDialog({
          type: 'alert',
          confirmBtn: {
              text: this.$t('common.confirm')
          },
          content: this.$t('navigate.plzAllowLocation')
        }).show()
        return
      }
      if (!this.inThere) {
        let text = ''
        if (this.siteId === '245') {
          text = '亲，你的当前位置不在RWS'
        } else if (this.siteId === '129') {
          text = '亲，你的当前位置不在新加坡'
        }  else if (this.siteId === '33') {
          text = '亲，你的当前位置不在德国'
        } else {
          text = '亲，你的当前位置不在圣淘沙'
        }
        this.toast = this.$createToast({
          time: 1500,
          type: 'txt',
          txt: text
        })
        this.toast.show()
        return
      }
      if (this.startGeo && this.startGeo.lon) {
        if (!this.currentMarker) {
          this.drawCurrentMarker(this.startGeo.lon, this.startGeo.lat)
        }
        this.map.panTo([this.startGeo.lon, this.startGeo.lat])
      } else {
        this.toast = this.$createToast({
          time: 1500,
          type: 'txt',
          txt: '未获取到你的位置，请稍后重试！'
        })
        this.toast.show()
      }
    },
    handleSlideChange (index) {
      const currentPoi = this.detail.plan_sites[index]
      this.popupDetail = {
        ...currentPoi.site,
        type: currentPoi.type,
        inTrip: true,
        planSiteId: currentPoi.id
      }

      this.showPopup = false
      this.$nextTick(() => {
        this.initPopup({
          geometry: {
            coordinates: [currentPoi.site.lon, currentPoi.site.lat]
          }
        }, { lon: currentPoi.site.lon, lat: currentPoi.site.lat })
        // 这里添加slide操作
        this.currentSlide = index
      })
    }
  }
}
</script>

<style lang="scss" scoped>
#map {
  height: 100vh;
}
.trip-detail-wrapper {
	padding-bottom: 40px;
}
.trip-detail {
  position: relative;
  height: 100vh;
}

.trip-wrapper {
  position: absolute;
  bottom: 0;
  left: 0;
  right: 0;
  background-color: rgba(255, 255, 255, 0.85);
  padding: 27px 10px 12px;
  margin-bottom: env(safe-area-inset-bottom);
  z-index: 30;
}

.scroll-wrapper {
  height: 84px;
}

.swiper-wrap {
  width: 330px;
  overflow: visible;
}
.cube-slide {
  overflow: visible;
}

.site-wrapper {
  display: flex;
  height: 84px;
}

.card {
  display: flex;
  align-items: center;
  justify-content: space-between;
  background-color: #ffffff;
  box-shadow: 0 2px 6px 0 rgba(0, 0, 0, 0.1);
  width: 279px;
  height: 82px;
  padding-right: 8px;

  &-img {
    width: 82px;
    height: 82px;
    flex-shrink: 0;
    background-color: #ccc;

    img {
      display: block;
      height: 100%;
      width: 100%;
      object-fit: cover;
    }
  }

  &-detail {
    padding-left: 12px;
    flex: 1;
  }

  &-title {
    font-size: 16px;
    line-height: 22px;
    font-weight: bold;
    font-family: "Montserrat";
    color: #3d3d3d;
    margin-bottom: 9px;
    width: 130px;
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
  }

  &-time,
  &-play {
    font-size: 12px;
    line-height: 17px;
    margin-top: 4px;
    color: #888888;
    width: 130px;
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
  }

  &-btns {
    display: flex;
    flex-direction: column;
    justify-content: space-between;

    .navigate-btn {
      width: 30px;
      height: 30px;
      border-radius: 50%;
      background-color: #f8a909;
      display: flex;
      align-items: center;
      justify-content: center;
      margin-bottom: 8px;

      img {
        width: 16px;
        height: 16px;
        display: block;
        position: relative;
        top: 1px;
        left: -1px;
      }
    }
  }
}

.route {
  margin: 0 10px;
  font-size: 12px;
  color: #888888;
  text-align: center;
  align-self: center;

  img {
    width: 12px;
    height: 15px;
    display: block;
    margin: 0 auto;
  }

  .number {
    line-height: 17px;
    margin-top: 10px;
  }
}
.optimize-btn {
  position: absolute;
  left: 18px;
  top: -20px;
  width: 38px;
  height: 38px;
  border-radius: 50%;
  box-shadow: 0 2px 6px 0 rgba(0, 0, 0, 0.22);
  background-color: #ffffff;
  display: flex;
  align-items: center;
  justify-content: center;

  img {
    width: 21px;
    height: 21px;
    display: block;
  }
}

.add-btn {
  position: absolute;
  top: -20px;
  left: 50%;
  margin-left: -60px;
  display: flex;
  align-items: center;
  justify-content: center;
  width: 120px;
  height: 40px;
  border-radius: 20px;
  background-color: #f8a909;

  img {
    width: 15px;
    height: 14px;
    display: block;
    margin-right: 4px;
  }

  span {
    font-size: 16px;
    line-height: 22px;
    color: #ffffff;
  }
}

.filter-btn {
  position: absolute;
  bottom: 15px;
  margin-bottom: env(safe-area-inset-bottom);
  right: 17px;
  z-index: 30;

  &.has-site {
    bottom: 155px;
  }

  &.show-site {
    bottom: 106px;
  }

  img {
    width: 41px;
    height: 41px;
    display: block;
  }
}

.info-window {
  position: absolute;
  bottom: 12px;
  left: 12px;
  right: 12px;
  background-color: #ffffff;
  display: flex;
  align-items: center;
  z-index: 30;
  margin-bottom: env(safe-area-inset-bottom);

  .info-img {
    width: 82px;
    height: 82px;
    background-color: #cccccc;
    flex-shrink: 0;

    img {
      height: 100%;
      width: 100%;
      display: block;
      object-fit: cover;
    }
  }

  .info-detail {
    padding: 0 12px;
    flex: 1;
  }

  .info-name {
    font-size: 16px;
    color: #3d3d3d;
    line-height: 22px;
    font-weight: bold;
    font-family: "Montserrat";
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
    max-width: 240px;
  }

  .info-labels {
    display: flex;
    align-items: center;

    .label {
      padding: 0 4px;
      font-size: 10px;
      line-height: 14px;
      font-size: 10px;
      color: #ed9107;
      border: 1px solid #ed9107;
      border-radius: 2px;
      margin-right: 5px;
      margin-top: 3px;
    }
  }

  .info-footer {
    display: flex;
    justify-content: space-between;
    align-items: center;
    margin-top: 11px;
  }

  .info-price {
    display: flex;
    align-items: baseline;
    color: #60c2ed;

    .price-text {
      font-size: 14px;
      font-weight: bold;
      font-family: "Montserrat";
    }

    .price-icon {
      font-size: 12px;
      font-weight: bold;
      font-family: "Montserrat";
    }
  }
}

.trip-popup {
  background-color: rgba(38, 39, 40, 0.8);
  border-radius: 4px;
  width: 114px;
  padding-left: 10px;
  position: relative;

  &:after {
    content: '';
    width: 100%;
    height: 1px;
    background-color: rgba(255, 255, 255, 0.3);
    position: absolute;
    top: 50%;
    left: 0;
  }

  .add-trip,
  .remove-trip,
  .set-start {
    display: flex;
    align-items: center;
    height: 42px;
  }

  .text {
    font-size: 12px;
    position: relative;
    top: 1px;
    color: #ffffff;
    display: block;
  }

  .add-trip img {
    width: 16px;
    height: 15px;
    display: block;
    margin-right: 7px;
  }

  .remove-trip img {
    width: 17px;
    height: 17px;
    display: block;
    margin-right: 6px;
  }

  .set-start img {
    width: 17px;
    height: 19px;
    display: block;
    margin-right: 6px;
  }
}

.current-locate {
  position: absolute;
  left: 18px;
  width: 38px;
  height: 38px;
  border-radius: 50%;
  box-shadow: 0 2px 2px 0 rgba(0, 0, 0, 0.2);
  background-color: #ffffff;
  display: flex;
  align-items: center;
  justify-content: center;
  bottom: 158px;
  margin-bottom: env(safe-area-inset-bottom);
  z-index: 30;

  &.no-sites {
    bottom: 15px;
  }

  &.has-popup {
    bottom: 108px;
  }

  img {
    width: 25px;
    height: 26px;
  }
}
.current-marker {
  z-index: 20;
  transform: translate(-9999px, -9999px);
  .circle {
    width: 30px;
    height: 30px;
    border-radius: 50%;
    background: url('/image/navigate/current-marker.svg') no-repeat center center;
    z-index: 2;
    position: relative;
    background-size: 100% 100%;
  }

  .arrow {
    position: absolute;
    border: 5px solid transparent;
    border-bottom: 5px solid #00AAE5;
    bottom: 100%;
    left: 50%;
    margin-left: -5px;
    margin-bottom: -2px;
    // box-shadow: 0 2px 4px 0 rgba(0, 0, 0, 0.1);
  }
}
</style>
